import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class FullMenuConceptResolver  {
    resolve() {
      return (window.innerWidth > 1367);
    }
}
